import { render, staticRenderFns } from "./foodcomment.vue?vue&type=template&id=30fd6520"
import script from "./foodcomment.vue?vue&type=script&lang=js"
export * from "./foodcomment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports